export const DEFAULT_RIGHT_PX_WHEN_STICKY_AT_BOTTOM_RIGHT = 16;
export const DEFAULT_BOTTOM_PX_WHEN_STICKY_AT_BOTTOM_RIGHT =
  DEFAULT_RIGHT_PX_WHEN_STICKY_AT_BOTTOM_RIGHT;
export const DEFAULT_WIDTH_PX_WHEN_STICKY_AT_BOTTOM_RIGHT = 300;
export const NARROW_WINDOW_WIDTH_PX = 800;
export const REASONABLY_HORIZONTAL_ASPECT_RATIO = 1.5;
export const MINIMUM_WIDTH_PX_WHEN_STICKY_AT_BOTTOM_RIGHT = 200;
